import React, { useState } from 'react';
import { Button } from 'antd';
import { FileTextOutlined, HistoryOutlined } from '@ant-design/icons';
import ChangeHistory from './ChangeHistory';
import ChangeLogPanel from './ChangeLogPanel';

const Fact = ({ label, children }: { label: string; children: React.ReactNode }) => (
    <div className="ci-bar__fact">
        <span className="ci-bar__label">{label}</span>
        <span className="ci-bar__value">{children}</span>
    </div>
);

/**
 * Strip at the top of an expanded entry: the history and log toggles and a
 * couple of facts on the left, POV actions on the right. Timestamps
 * deliberately live in the history rather than here — the feed says when each
 * change happened and who made it, which a bare created/updated pair cannot.
 *
 * The log is shown from here, under the history, while its toggle is on; a
 * change with nothing logged has no toggle and no log.
 */
const ChangeDetailBar = ({
    record,
    resource,
    children,
}: {
    record: any;
    resource?: string;
    children?: React.ReactNode;
}) => {
    const [showHistory, setShowHistory] = useState(false);
    const [showLog, setShowLog] = useState(false);
    const hasLog = Boolean((record.log || '').trim());

    return (
        <>
            <div className="ci-bar">
                <div className="ci-bar__facts">
                    <Button
                        size="small"
                        icon={<HistoryOutlined />}
                        onClick={() => setShowHistory((prev) => !prev)}
                        aria-expanded={showHistory}
                    >
                        {showHistory ? 'Hide history' : 'Show history'}
                    </Button>
                    {hasLog && (
                        <Button
                            size="small"
                            icon={<FileTextOutlined />}
                            onClick={() => setShowLog((prev) => !prev)}
                            aria-expanded={showLog}
                        >
                            {showLog ? 'Hide log' : 'Show log'}
                        </Button>
                    )}
                    {record.submission?.id && <Fact label="Submission">#{record.submission.id}</Fact>}
                    {record.is_dependant && <Fact label="Dependant">Yes</Fact>}
                </div>

                {children && <div className="ci-bar__actions">{children}</div>}
            </div>

            {showHistory && (
                <section className="ci-block">
                    <ChangeHistory resource={resource} id={record.id} />
                </section>
            )}

            {hasLog && showLog && <ChangeLogPanel log={record.log} />}
        </>
    );
};

export default ChangeDetailBar;
